<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
import { ref } from 'vue';
import { useOrderStore } from '@/stores/order';

const props = defineProps({
    order: {
        type: Object,
        required: true,
    },
});

const emit = defineEmits(['close-modal']);
const { update } = useOrderStore();

const form = ref({
    ...props.order,
});

const save = async () => {
    const action = update;
    await action({
        hash: form.value.hash,
        rx_number: form.value.rx_number,
    });

    emit('close-modal');
};
</script>

<template>
<ModalWrapper>
    <template #header>{{
        $t("label.mode_what", { mode: "Update", what: "order status" })
    }}</template>
    <template #subheader>{{
        $t("label.create_or_edit", { what: "order" })
    }}</template>

    <form @submit.prevent="save">
        <div class="md:grid md:grid-cols-2 gap-x-4">
            <StyledInput
                v-model="form.rx_number"
                name="rx_number"
                :label="$t('label.rx_number')" />
        </div>
    </form>

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
